import { useTranslation } from "react-i18next"
import { useGetFilterOptionsQuery } from "../../../../app/services/book/bundle"
import { buildOPT } from "../utils/constants"

export function useFilterOptions() {
  const { t } = useTranslation()
  const { data, isLoading } = useGetFilterOptionsQuery()

  const STATIC_OPT = buildOPT(t)

  const OPT = {
    ...STATIC_OPT,
    status: data?.statuses,
    sellers: data?.sellers ?? [],
    suppliers: data?.suppliers ?? [],
    users: data?.users ?? [],
    moderator: data?.moderators ?? [],
    market: data?.market ?? [],
    states: data?.states ?? [],
    modules: data?.modules ?? STATIC_OPT.modules,
    services: data?.services ?? [],
    package: data?.package ?? [],
    referer: data?.referer ?? [],
  }

  return { OPT, quickFilters: data?.quick_filters ?? [], isLoading }
}
